<template>
    <div class="content-container mb-4">
        <div class="post-section" v-if="section.type === 'text'"
            v-html="section.data">
        </div>
        <div class="post-section row" v-if="section.type === 'photo'"
            :class="{'image-joined-contaier': section.addedClass}">
            <img :src="item" :alt="articleTitle" v-for="(item, index) in section.data"
                :key="index" class="img-fluid display-image mb-md-3 px-2"
                :class="{'col': section.data.length <= 3, 'col-md-4': section.data.length > 3,
                'image-joined': section.addedClass}">
        </div>
        <div class="post-section" v-if="section.type === 'video' && youtube_parser(section.data)">
            <youtube :video-id="youtube_parser(section.data)" width="100%"></youtube>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Section',
    props: ['section', 'articleTitle'],
    methods: {
        youtube_parser(url) {
            var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
            var match = url.match(regExp);
            return (match&&match[7].length==11)? match[7] : false;
        }
    }
}
</script>

<style scoped>
.display-image {
    border-radius: 6px;
}
@media (max-width: 768px) {
    .display-image {
        flex: 0 0 100%;
        max-width: 100%;
    }
    .image-joined {
        margin-top: -20px;
        margin-bottom: -20px;
    }
}
.image-joined-container {
    padding-left: 35px;
    padding-right: 35px;
}
.image-joined {
    margin-left: -35px;
    margin-right: -35px;
}
</style>